import routerOptions0 from "/builds/WeArePublic/wap-app/node_modules/.pnpm/nuxt@3.21.11_@oxc-project+types@0.153.0_@types+node@22.20.5_@vue+compiler-sfc@3.5.13_ca_4dda6e840978e766d0ce94b2ef57e7b8/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}